import { AccSubCat } from "../models/Master/AccSubCat";
import { AccSubCategoryFilter } from "../models/Master/AccSubCategoryFilter";
import { User } from "../models/Master/User";
import { UserFilter } from "../models/Master/UserFilter";
import { RoleFilter } from "../models/Master/RoleFilter";
import { AxiosConfig } from "./AxiosConfig";
import { Role } from "../models/Master/Role";
import { HistoryFilters } from "../models/Master/HistoryFilters";
import { UserListRespone } from "../models/Master/UserListRespone";
import { ProcurementCategoryListResponse } from "../models/Master/ProcurementCategoryListResponse";
import { ProcurementCategoryFilter } from "../models/Master/ProcurementCategoryFilter";
import { ProcurementCategoryObj } from "../models/Master/ProcurementCategory";
import { ProcurementSubCategory } from "../models/ProcurementSubCategory";
import { VendorCategory } from "../models/Master/VendorCategory";
import { ProcurementCategorySummary, ProcurementSubcategorySummary } from "../models/Master/ProcurementCategorySummary";
import { InActiveVendorObj } from "../models/Master/InActiveVendor";

const getAccSubCategries = async (
  filterData: AccSubCategoryFilter,
  successCallback: (accSubCategories: Array<AccSubCat>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.post(`Vendor/GetAccSubCategory`, filterData);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const saveAccSubCategory = async (
  accSubCatCreateData: AccSubCat,
  successCallback: (accSubCategory: AccSubCat) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.post(`Vendor/GetAccSubCategory`, accSubCatCreateData);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const deleteAccSubCategory = async (
  accSubCatCreateData: AccSubCat,
  successCallback: (accSubCategory: AccSubCat) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.post(`Vendor/GetAccSubCategory`, accSubCatCreateData);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getUsersList = async (
  filterData: UserFilter,
  successCallback: (usersData: UserListRespone) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.post(`ADUser/SearchAduser`, filterData);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getUsersByRoles = async (
  companyCode: string,
  roleIds: number[],
  successCallback: (usersData: User[]) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`ADUser/GetByRoles`, { 
      params: { companyCode: companyCode, roleIds: roleIds }
    });
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getUsers = async (
  successCallback: (usersData: User[]) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`ADUser/GetUsers`);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const saveUser = async (
  userCreateData: User,
  successCallback: (user: User) => void,
  errorCallback: (error: Error) => void
) => {
  // let createUser = {
  //   "Id":userCreateData.id,
  //   "emailaddress":userCreateData.emailAddress,
  //   "MappedCompanies":userCreateData.mappedCompanies,
  //   "UserRoles":userCreateData.userRoles.map((role)=>{
  //     return {"id":role.id};
  //   }),
  //   "GrpClusters":[]
  // };
  try {
    const resp = await AxiosConfig.post(`ADUser/AddAdUser`, userCreateData);
    successCallback(resp.data.result);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const deleteUser = async (
  userCreateData: User,
  successCallback: (responseData: any) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.post(`ADUser/DeactivateAdUser`, userCreateData);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getRoleList = async (
  filterData: RoleFilter,
  successCallback: (roleList: Array<Role>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`Vendor/GetRoleList`, { params: filterData });
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const saveRole = async (
  roleData: Role,
  successCallback: (Role: Role) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.post(`Vendor/GetRoleList`, roleData);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const deleteRole = async (
  roleData: Role,
  successCallback: (Role: Role) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.post(`Vendor/GetRoleList`, roleData);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getHistoryData = async (
  filters: HistoryFilters,
  successCallback: (data: Array<any>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`RequestHistory/GetRequestHistory`, {params: filters});

    successCallback(resp.data);
    
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};
const getProcurementCategories = async (
  filterData: ProcurementCategoryFilter,
  successCallback: (procurementData: ProcurementCategoryListResponse) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.post(`ProcurementCategory/GetProcurementCategory`,filterData);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};
const getProcurementSubcategorySummaries = async (
  requestTypeId: number,
  vendorCategoryId: number,
  successCallback: (procurementData: ProcurementSubcategorySummary[]) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`ProcurementCategory/GetProcurementCategory`,
      {params: {vendorCategoryId: vendorCategoryId, requestTypeId: requestTypeId}});
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};
const deleteProcurementCategory = async (
  data: ProcurementCategoryObj,
  successCallback: (responseData: any) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.post(`ProcurementCategory/DeactivateProcurementCategory`, data);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getVendorCategories = async (
  //filterData: AccSubCategoryFilter,
  successCallback: (vendorCategories: Array<VendorCategory>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`VendorCategory/GetVendorCategory`);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const saveProcurementCategory = async (
  data: ProcurementCategoryObj,
  successCallback: (proc: ProcurementCategoryObj) => void,
  errorCallback: (error: Error) => void
) => {
  
  try {
    const resp = await AxiosConfig.post(`ProcurementCategory/SaveProcurementCategory`, data);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getInActiveVendorList = async (
  successCallback: (data: Array<InActiveVendorObj>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`VendorBlockExcemption/GetInActiveVendorList`);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getProcurementSubCategories = async (
  successCallback: (proList: Array<ProcurementSubCategory>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`ProcurementCategory/GetProcurementSubCategories`);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};


export const MasterDataService = {
  getAccSubCategries,
  saveAccSubCategory,
  //updateAccSubCategory,
  deleteAccSubCategory,
  getUsersList,
  saveUser,
  deleteUser,
  getRoleList,
  saveRole,
  deleteRole,
  getHistoryData,
  getUsersByRoles,
  getUsers,
  getProcurementCategories,
  getProcurementSubcategorySummaries,
  deleteProcurementCategory,
  getVendorCategories,
  saveProcurementCategory,
  getInActiveVendorList,
  getProcurementSubCategories,
};